import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { DaterangepickerConfig, DaterangepickerComponent } from 'ng2-daterangepicker';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { QueryParameters } from '../../../analytics-core/interfaces/query-parameters.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-datepicker',
	styleUrls: ['./datepicker.component.css'],
	templateUrl: './datepicker.component.html'
})
export class DatepickerComponent implements OnInit, AfterViewInit {
	public type: string;
	public diff: number;

	date: any;
	public daterange: any = {
		end: moment().subtract(1, 'day').format('YYYY-MM-DD'),
		label: '',
		start: moment().subtract(1, 'day').subtract(1, 'months').format('YYYY-MM-DD')
	};
	public isActive = false;
	public optionsVal: any = {
		alwaysShowCalendars: false,
		locale: { format: 'M-D-YYYY' }
	};

	@ViewChild(DaterangepickerComponent)
	private picker: DaterangepickerComponent;

	constructor(
		private daterangepickerOptions: DaterangepickerConfig,
		private activatedRoute: ActivatedRoute,
		private analyticsService: AnalyticsService
	) {
		this.daterangepickerOptions.settings = {
			alwaysShowCalendars: true,
			locale: { format: 'M-D-YYYY' },
			maxDate: moment().format('M-D-YYYY')
		};
	}

	ngAfterViewInit(): void {
		this.picker.datePicker.setStartDate(moment().subtract(1, 'months').format('M-D-YYYY'));
	}

	ngOnInit(): void {
		this.activatedRoute.queryParams.subscribe((obj: QueryParameters) => {
			this.daterange = this.analyticsService.processQueryParamsDateRanges(obj);
			this.applyDate(this.daterange);
		});
		EmitterService.get(EVENT_EMITTERS.DATE_RANGE).emit({
			endDate: this.daterange.end,
			startDate: this.daterange.start
		});
	}

	public applyDate(e: any): void {
		this.daterange.start = e.startDate;
		this.daterange.end = e.endDate;
		EmitterService.get(EVENT_EMITTERS.DATE_RANGE).emit({
			endDate: moment(this.daterange.end).format('YYYY-MM-DD'),
			startDate: moment(this.daterange.start).format('YYYY-MM-DD')
		});
		setTimeout(() => {
			EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).emit(true);
		}, 500);
	}

	public calendarHideDaterangepicker(event: any): void {
		this.isActive = false;
		setTimeout(() => {
			this.picker.datePicker.setStartDate(moment(this.daterange.start).format('M-D-YYYY'));
			this.picker.datePicker.setEndDate(moment(this.daterange.end).format('M-D-YYYY'));
		});
	}

	public calendarShowDaterangepicker(event: any): void {
		this.isActive = true;
	}
}
